module.exports = __webpack_public_path__ + "assets-cabinet/img/transactions-icon.426ce38a.svg";